'use strict';
import * as $j_app$002edata$002e$002dPayment$002dDetails$0024package$0024$002dI$002dB$002dA$002dN$0024 from "./app.data.-Payment-Details$package$-I-B-A-N$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$package$IBANForm$() {
  this.aEK = null;
  this.aEX = null;
  this.aEP = null;
  this.aEQ = false;
  this.aEV = null;
  this.aEW = false;
  this.aEL = null;
  this.aEM = false;
  this.aET = null;
  this.aEU = false;
  this.aER = null;
  this.aES = false;
  this.aEN = null;
  this.aEO = false;
  $n_Lapp_data_PaymentDetails$package$IBANForm$ = this;
  this.aEK = $j_app$002edata$002e$002dPayment$002dDetails$0024package$0024$002dI$002dB$002dA$002dN$0024.$m_Lapp_data_PaymentDetails$package$IBAN$();
  this.aEX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dPayment$002dDetails$0024package$0024$002dI$002dB$002dA$002dN$0024.$m_Lapp_data_PaymentDetails$package$IBAN$());
}
export { $c_Lapp_data_PaymentDetails$package$IBANForm$ as $c_Lapp_data_PaymentDetails$package$IBANForm$ };
$p = $c_Lapp_data_PaymentDetails$package$IBANForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PaymentDetails$package$IBANForm$;
/** @constructor */
function $h_Lapp_data_PaymentDetails$package$IBANForm$() {
}
export { $h_Lapp_data_PaymentDetails$package$IBANForm$ as $h_Lapp_data_PaymentDetails$package$IBANForm$ };
$h_Lapp_data_PaymentDetails$package$IBANForm$.prototype = $p;
$p.eR = (function() {
  return this.aEK;
});
$p.eO = (function() {
  return this.aEX;
});
$p.b9 = (function() {
  if ((!this.aEQ)) {
    this.aEP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aEQ = true;
  }
  return this.aEP;
});
$p.b3 = (function() {
  if ((!this.aEW)) {
    this.aEV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aEW = true;
  }
  return this.aEV;
});
$p.aG = (function() {
  if ((!this.aEM)) {
    this.aEL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aEM = true;
  }
  return this.aEL;
});
$p.az = (function() {
  if ((!this.aEU)) {
    this.aET = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aEU = true;
  }
  return this.aET;
});
$p.aY = (function() {
  if ((!this.aES)) {
    this.aER = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aES = true;
  }
  return this.aER;
});
$p.brY = (function() {
  if ((!this.aEO)) {
    this.aEN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "IBAN";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aEO = true;
  }
  return this.aEN;
});
var $d_Lapp_data_PaymentDetails$package$IBANForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$package$IBANForm$, "app.data.PaymentDetails$package$IBANForm$", ({
  EH: 1,
  N: 1
}));
export { $d_Lapp_data_PaymentDetails$package$IBANForm$ as $d_Lapp_data_PaymentDetails$package$IBANForm$ };
var $n_Lapp_data_PaymentDetails$package$IBANForm$;
function $m_Lapp_data_PaymentDetails$package$IBANForm$() {
  if ((!$n_Lapp_data_PaymentDetails$package$IBANForm$)) {
    $n_Lapp_data_PaymentDetails$package$IBANForm$ = new $c_Lapp_data_PaymentDetails$package$IBANForm$();
  }
  return $n_Lapp_data_PaymentDetails$package$IBANForm$;
}
export { $m_Lapp_data_PaymentDetails$package$IBANForm$ as $m_Lapp_data_PaymentDetails$package$IBANForm$ };
//# sourceMappingURL=app.data.-Payment-Details$package$-I-B-A-N-Form$.js.map
